import { render, staticRenderFns } from "./PosTransactionDetails.vue?vue&type=template&id=7df80bc3&"
import script from "./PosTransactionDetails.vue?vue&type=script&lang=js&"
export * from "./PosTransactionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports